import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";
import { validateData, getContent, removeStaleRow, deleteRecord } from "./tableManager.js";
import { currentTable } from "../../../../app/viewManager.js";

async function collectData() {
    const content = getContent();
    if (!content) return null;
    return {
        Name:        content.querySelector("#inputApplicationName")?.getValue?.()        ?? "",
        Description: content.querySelector("#inputApplicationDescription")?.getValue?.() ?? "",
        ProjectIds:  content.querySelector("#dropdownProjects")?.getValue?.()            ?? [],
    };
}

function toRowData(app) {
    return {
        id:          app.id,
        name:        app.name,
        description: app.description ?? "",
        projectIds:  app.projects.map(project => project.id),
        projectId:   app.projects.map(project => project.id).join("; ") + (app.projects.length ? ";" : ""),
        projectName: app.projects.map(project => project.name).join("; ") + (app.projects.length ? ";" : ""),
    };
}

function sortByName() { currentTable.setSort("name", "asc"); }

export async function loadApplications() {
    const grouped = await apiFetch("ApplicationProjects");
    currentTable.options.placeholder = "Keine Daten vorhanden";
    if (!Array.isArray(grouped)) { currentTable.replaceData([]); return; }

    const appData = grouped.map(toRowData);
    currentTable.setData(appData);
    sortByName();
    updateFilterOptions(appData, currentTable);
}

export async function createApplication() {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const newApp = await apiFetch("ApplicationProjects", "POST", {
        Name:        collectedData.Name,
        Description: collectedData.Description,
        ProjectIds:  collectedData.ProjectIds ?? [],
    });
    if (isErrorResult(newApp)) return newApp ? true : undefined;

    await currentTable.addRow(toRowData(newApp), true);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Applikation erfolgreich hinzugefügt!", "success");
    return newApp;
}

export async function updateApplication(applicationId) {
    const collectedData = await collectData();
    if (!collectedData) return;

    const missingFields = await validateData(collectedData);
    if (missingFields.length > 0) return true;

    const updatedApp = await apiFetch(`ApplicationProjects/${applicationId}`, "PATCH", {
        Name:        collectedData.Name,
        Description: collectedData.Description,
        ProjectIds:  collectedData.ProjectIds ?? [],
    });

    if (removeStaleRow(updatedApp, applicationId)) return;
    if (isErrorResult(updatedApp)) return updatedApp ? true : undefined;

    await currentTable.updateOrAddData([toRowData(updatedApp)]);
    sortByName();
    updateFilterOptions(currentTable.getData(), currentTable);
    toast("Applikation erfolgreich aktualisiert!", "success");
    return updatedApp;
}

export const deleteApplication = (applicationId) => deleteRecord("ApplicationProjects", applicationId, "Applikation erfolgreich gelöscht!");
